import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      border: '1px solid #D2D2D2',
      borderRadius: 6,
      padding: theme.spacing(1.5),

      '& > h3': {
        fontSize: '1.6rem',
        marginBottom: theme.spacing(1),
      },

      '& > span': {
        display: 'block',
        fontSize: '1rem',
        marginTop: theme.spacing(1.5),
        lineHeight: '1rem',
      },
    },
  }),
)
